module.exports = __webpack_public_path__ + "static/media/gukhwa-jangs.9f284dcf.jpg";